import { render, staticRenderFns } from "./beautyCenter.vue?vue&type=template&id=aa8cb2c8&scoped=true&"
import script from "./beautyCenter.vue?vue&type=script&lang=js&"
export * from "./beautyCenter.vue?vue&type=script&lang=js&"
import style0 from "./beautyCenter.vue?vue&type=style&index=0&id=aa8cb2c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa8cb2c8",
  null
  
)

export default component.exports